<template>

    <div class="flex flex-row px-2 py-2">
        <div class="flex">
            <div class="inline-block rounded-l px-3 py-1 text-white align-middle cursor-pointer" :class="{'bg-blue-700': linkType == 'RTMP', 'bg-blue-500': linkType == 'HLS'}" v-on:click="toggleType('RTMP')">
                RTMP
            </div>
            <div class="inline-block rounded-r px-3 py-1 text-white align-middle cursor-pointer" :class="{'bg-blue-700': linkType == 'HLS', 'bg-blue-500': linkType == 'RTMP'}" v-on:click="toggleType('HLS')">
                HLS
            </div>
        </div>
        <div class="flex-grow pl-5">
            <input type="text" class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-1 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" v-model="linkUrl" />
        </div>
    </div>

</template>

<script>

	export default {
		name: 'StreamUrl-Comp',
		data () {
			return {
                linkType: "RTMP",
                linkUrl: "rtmp://rtmp.edge-media.livestormchasing.com/live/" + this.streamId,
            }
        },
        props: [
            'streamId',
        ],
		mounted() {
		},
		methods: {
            toggleType(link) {
                this.linkType = link;
                if(link == "RTMP") {
                    this.linkUrl = "rtmp://rtmp.edge-media.livestormchasing.com/live/" + this.streamId;
                } else {
                    // link is hls
                    this.linkUrl = "https://edge-media.livestormchasing.com/hls/" + this.streamId + "/index.m3u8";
                }
            }
		},
	}
</script>

